<script setup lang="ts">
import {ref, watch} from 'vue';
import {useI18n} from 'vue-i18n';
import type {ValidationRule} from 'quasar';

const model = defineModel<string>();

defineProps<{
  label: string;
  rules?: ValidationRule<string>[];
  autocomplete?: string;
}>();

const {t} = useI18n();
const visible = ref(false);

function toggle(): void {
  visible.value = !visible.value;
}

// Reset visibility when the input is cleared so the next typed characters are masked again.
watch(model, val => {
  if (!val) {
    visible.value = false;
  }
});
</script>

<template>
  <q-input
    v-model="model"
    :type="visible ? 'text' : 'password'"
    :rules="rules"
    :label="label"
    :autocomplete="autocomplete"
  >
    <template #append>
      <q-btn
        v-if="model"
        flat
        dense
        round
        size="sm"
        :icon="visible ? 'visibility_off' : 'visibility'"
        :aria-label="visible ? t('hide_password') : t('show_password')"
        :aria-pressed="visible"
        @click="toggle"
      />
    </template>
  </q-input>
</template>
